import React from "react";
import PropTypes from "prop-types";
import { Row } from "components/Containers";
import Tags from "components/Tags";
import { TAG_COLORS, TAG_SIZE } from "components/Tags/Tag";

/**
 * ColumnDisciplines
 *
 * @param {Object} data
 * @param {Number} limit
 */
const ColumnDisciplines = ({ data, limit }) => (
  <Row gap="0.25rem">
    <Tags
      data={(data?.disciplines || []).map((discipline) => ({ name: discipline }))}
      limit={limit}
      unwrap
      {...TAG_COLORS.purple}
      size={TAG_SIZE.small}
    />
  </Row>
);

ColumnDisciplines.propTypes = {
  data: PropTypes.object.isRequired,
  limit: PropTypes.number,
};

ColumnDisciplines.defaultProps = {
  limit: 3,
};

export default ColumnDisciplines;
